// extracted by mini-css-extract-plugin
export default {"root":"PlasmicNotPaidStatusCard_root__XhTKO","text":"PlasmicNotPaidStatusCard_text__sfuYf"};